export default __webpack_public_path__ + "static/media/DSCs.15a5dd71.png";